import { call, put, select, takeLatest } from 'redux-saga/effects';
import { FLOW_TYPES } from '../../utils/constants';
import * as actions from '../actions';
import { submitConfirmationRequest, submitUnsubscribeEmailRequest } from '../api';
import { SUBMIT_FORM_REQUEST } from '../types';

export function* unsubscribeEmailSaga({ payload: { email, flow, userHash } }) {
  try {
    yield put(actions.addLoader(SUBMIT_FORM_REQUEST));
    const {
      Data: { csrfToken, locale },
    } = yield select();

    const formHeaders = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'CSRF-Token': csrfToken,
      },
    };

    let data;
    if (flow === FLOW_TYPES.CONFIRMATION) {
      ({ data } = yield call(
        submitConfirmationRequest,
        {
          email,
          locale,
        },
        formHeaders
      ));
    } else {
      ({ data } = yield call(
        submitUnsubscribeEmailRequest,
        {
          ...(email != null ? { email } : {}),
          locale,
          ...(userHash != null ? { userHash } : {}),
        },
        formHeaders
      ));
    }

    if (!data || !data.success) {
      throw new Error();
    } else {
      yield put(actions.submitFormSuccess());
    }
  } catch (e) {
    yield put(actions.submitFormFailure());
  }
  yield put(actions.removeLoader(SUBMIT_FORM_REQUEST));
}

export function* unsubscribeEmailSagaWatch() {
  yield takeLatest(SUBMIT_FORM_REQUEST, unsubscribeEmailSaga);
}
